import { render } from "./Pokedex.vue?vue&type=template&id=2019882c"
import script from "./Pokedex.vue?vue&type=script&lang=js"
export * from "./Pokedex.vue?vue&type=script&lang=js"

import "./Pokedex.vue?vue&type=style&index=0&id=2019882c&lang=css"

import exportComponent from "/home/soder/git/pokedex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__